import { Category } from '../types/event-response.type';

export function unwrapCategoriesUtil(
  categories: Category[],
  parentId: number = 0
): Category[] {
  const categoryList: Category[] = [];

  categories.forEach((category: any) => {
    categoryList.push({
      ...category,
      category_parent_id: parentId || null,
    });

    if (category.subcategories) {
      categoryList.push(
        ...unwrapCategoriesUtil(category.subcategories, category.category_id)
      );
    }
  });

  return categoryList;
}
